<!--
 * @Author: your name
 * @Date: 2020-07-28 18:05:00
 * @LastEditTime: 2020-12-01 10:26:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-gaokao-ebook\src\components\qr-code\qr-code.vue
--> 
<template>
  <div class="qr_code" style="width:200px;height:200px;">
		<img id="img" style="width:200px;height:200px;" :src="code_url" alt="">
  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  data() {
    return {
      code_url : ''
    };
  },
  props:
  {
    payCodeUrl : String
  },
  methods: {
    makeCode() {
    let url = this.payCodeUrl;
		 this.code_url = url;
     let canvas = document.createElement("canvas");
     canvas.width = "100px";
     canvas.height = "100px";
     QRCode.toCanvas(canvas, this.code_url, error => {
       if (error) {
         console.log(error);
       } else {
         this.code_url = canvas.toDataURL("image/jpeg");
       } 
     });
    },
  },

  mounted() {
    this.makeCode();
  }
};
</script>
<style lang="stylus" scoped>
</style>